import { FC, ReactElement, useState } from "react"
import { User, UpdateUserAsAdminRequestSchema, UsersService } from "../sdk"
import { Controller, useForm } from "react-hook-form"
import { useParams } from "react-router-dom"
import Input from "../components/Input"
import Button from "../components/Button"
import useError from "../hooks/useError"
import classNames from "classnames"
// import useConfirmModal from "../hooks/useConfirmModal"
import { userStatusMap } from "../constants/user"
import Col from "./Col"

type Props = {
  defaultValues: User
  onSuccess?(userData: User): void
}

const Form: FC<Props> = ({
  defaultValues: {
    email,
    username,
    firstname,
    lastname,
    birthDate,
    status,
    organizationName
  },
  onSuccess
}) => {
  const { handleSubmit, control, formState } = useForm<UpdateUserAsAdminRequestSchema["updates"]>()
  const { handleError } = useError()
  const { id } = useParams()
  // const { openConfirmModal, closeConfirmModal } = useConfirmModal()

  const [loading, setLoading] = useState<boolean>(false)

  const onSubmit = async({
    username,
    firstname,
    lastname,
    birthDate,
    organizationName,
    status,
    email
  }: UpdateUserAsAdminRequestSchema["updates"]): Promise<void> => {
    setLoading(true)
    try {
      const { data } = await UsersService.updateUserAsAdmin({
        handler: { userId: Number(id) },
        updates: {
          username,
          firstname,
          lastname,
          birthDate: birthDate === "" || birthDate === null ? undefined : new Date(birthDate!).toISOString(),
          organizationName,
          status,
          email
        }
      })

      if (onSuccess) {
        onSuccess(data)
      }
    } catch (err) {
      handleError(err)
    }
    setLoading(false)
  }

  return (
    <form onSubmit={handleSubmit(onSubmit)} className={classNames("grid grid-cols-12 gap-2", loading && "opacity-50 pointer-events-none")}>
      <Col lg={6}>
        <Controller
          name="username"
          control={control}
          defaultValue={username}
          rules={{
            required: "Campo obbligatorio"
          }}
          render={({ field: { onChange, value } }): ReactElement => {
            return (
              <Input value={value} onChange={onChange} label="Username" error={formState.errors.username?.message} />
            )
          }}
        />
      </Col>

      <Col lg={6}>
        <Controller
          name="email"
          control={control}
          defaultValue={email}
          rules={{
            required: "Campo obbligatorio"
          }}
          render={({ field: { onChange, value } }): ReactElement => {
            return (
              <Input value={value} onChange={onChange} label="Email" error={formState.errors.email?.message} />
            )
          }}
        />
      </Col>

      <Col lg={6}>
        <Controller
          name="firstname"
          defaultValue={firstname}
          control={control}
          rules={{
            required: "Campo obbligatorio"
          }}
          render={({ field: { onChange, value } }): ReactElement => {
            return (
              <Input value={value} onChange={onChange} label="Nome" error={formState.errors.firstname?.message} />
            )
          }}
        />
      </Col>

      <Col lg={6}>
        <Controller
          name="lastname"
          defaultValue={lastname}
          control={control}
          rules={{
            required: "Campo obbligatorio"
          }}
          render={({ field: { onChange, value } }): ReactElement => {
            return (
              <Input value={value} onChange={onChange} label="Cognome" error={formState.errors.lastname?.message} />
            )
          }}
        />
      </Col>

      <Col lg={6}>
        <Controller
          name="birthDate"
          control={control}
          defaultValue={birthDate?.split("T")[0] || ""}
          rules={{
            required: "Campo obbligatorio"
          }}
          render={({ field: { onChange, value } }): ReactElement => {
            return (
              <Input type="date" value={value} onChange={onChange} label="Data di nascita" error={formState.errors.birthDate?.message} />
            )
          }}
        />
      </Col>

      <Col lg={6}>
        <Controller
          name="organizationName"
          control={control}
          defaultValue={organizationName || ""}
          render={({ field: { onChange, value } }): ReactElement => {
            return (
              <Input value={value!} onChange={onChange} label="Nome organizzazione" error={formState.errors.organizationName?.message} />
            )
          }}
        />
      </Col>

      <Col lg={6}>
        <Controller
          name="status"
          control={control}
          defaultValue={status}
          render={({ field: { onChange, value } }): ReactElement => {
            return (
              <div>
                <div className="input__label">Stato: </div>

                <select
                  value={value}
                  onChange={onChange}
                  className="user-page__select"
                >
                  {Object.entries(userStatusMap).map(([key, value]): ReactElement => {
                    return (
                      <option key={key} value={key}>{value}</option>
                    )
                  })}
                </select>
              </div>
            )
          }}
        />
      </Col>

      {/* <Button
        className="mt-8 w-full"
        onClick={(): void => {
          openConfirmModal({
            onConfirm: (): void => {
              // Pending
            },
            content: <div className="mb-8 mt-4 text-xl">Rendere <span className="font-bold italic">{username}</span> Admin?</div>
          })
        }}
      >
        Rendi Admin
      </Button> */}

      <Col>
        <Button type="submit" className="w-full mt-2">Salva</Button>
      </Col>
    </form>
  )
}
export default Form